export default __webpack_public_path__ + "static/media/arsalanpic.31b7d163.jpeg";